<script setup>
import banner from './assets/ui/banner.bmp';
import footer from './assets/ui/footer.bmp';
</script>

<template>
<header>
    <img :src="banner" alt="Nápis Rusínsky prekladač s tradičným folkórnym vzorom">
    <nav>
        <router-link class="link px-2 py-2 mx-5" to="/">Domov</router-link>
        <router-link class="link px-2 py-2 mx-5" to="/info">Info</router-link>
        <router-link class="link px-2 py-2 mx-5" to="/preklad">Preklad</router-link>
    </nav>
</header>
<main>
    <router-view />
</main>
<footer>
    <img :src="footer" alt="Tradičný folklórny vzor" type="image/bmp">
</footer>
</template>

<style scoped>
@import url('https://fonts.bunny.net/css2?family=Tiny5&display=swap');

.link {
    color: black;
    text-decoration: underline;
    font-family: "Tiny5", sans-serif;
    font-size: x-large;
    border: 7px solid rgb(0, 0, 0, 0);
}
.link:hover {
    border: 7px solid black;
}
nav {
    position: absolute;
    top: 2vh;
    right: 6vw;
}
main {
    flex: 1;
}
footer img {
    display: block;
    width: 100%;
    height: auto;
}
@media (max-width: 600px) {
    footer, header { height: 8vh; }
    footer img, header img {
        height: 100%;
        object-fit: cover;
    }
    header img {
        object-position: right;
        transform: scaleX(-1);
    }
    /* reduce spacing of router links on small screens */
    nav {
        top: 1.5vh;
        right: 0;
    }
    nav .link {
        margin: 0 0.4rem !important; /* override mx-5 */
        padding: 0.2rem 0.4rem !important; /* smaller touch target but compact */
        font-size: x-large;
    }
}
</style>
<script>
export default {

}
</script>
